import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=9d079cfc&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d079cfc",
  null
  
)

export default component.exports